export default __webpack_public_path__ + "static/media/icons-gpa-1.42fbbbb4.png";